import { Box } from '@acko-tech/building-blocks.ui.common';
import { Text } from '@acko-tech/building-blocks.ui.typography';
import styled from 'styled-components';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 23px;
  @media (min-width: 768px) {
    flex-direction: column;
    text-align: left;
    align-items: flex-start;
  }
`;

export const TextContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const Heading = styled(Text)`
  color: #000;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const SubHeading = styled(Text)`
  color: var(--text-secondary-n-400, #5B5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const ImageWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 24px;
`;

export const Image = styled.img`
  width: 260px;
  height: 261px;
  aspect-ratio: 260/261;
`;
